import { render, staticRenderFns } from "./TurfaEua.vue?vue&type=template&id=51168e1d&lang=pug"
import script from "./TurfaEua.vue?vue&type=script&lang=js"
export * from "./TurfaEua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports